module.exports = __webpack_public_path__ + "static/media/java-fx-icon.c1323353.png";